import Seo from '@components/SEO';
import useIsMobileApp from '@hooks/useIsMobileApp';
import DefaultFooter from '@layouts/LayoutComponents/Footer';
import { ToastProvider } from '@shared/atoms';
import classNames from 'classnames';
import { TwitterCardType } from 'custom.d';
import React from 'react';
import { useLocation } from 'react-router';
import 'react-toastify/dist/ReactToastify.css';
import Header from './Header';
import styles from './index.module.scss';

const AuthenticationLayout: React.FunctionComponent<AuthenticationLayoutProps> = (props) => {
  const {
    children,
    title,
    description,
    name,
    type,
    organizationLogo,
    organizationAltText,
    hideHapstarLogoEnabled,
  } = props;
  const isMobileApp = useIsMobileApp();
  const location = useLocation();
  const isOnboarding = Boolean(location.pathname === '/onboarding-assessment');
  const isWelcomePage = Boolean(location.pathname === '/welcome');
  const hideHeaderAndFooter = location.pathname.startsWith('/login/verify');

  return (
    <div
      className={classNames([
        styles.hsAuthLayout,
        isMobileApp && !isOnboarding && styles.hsFooterMobile,
        isWelcomePage && styles.hsAuthLayoutWelcome,
      ])}
    >
      <Seo title={title} description={description} name={name} type={type} />
      <ToastProvider />
      {!hideHeaderAndFooter && (
        <Header
          organizationLogo={organizationLogo}
          organizationAltText={organizationAltText}
          hideHapstarLogoEnabled={hideHapstarLogoEnabled}
        />
      )}
      <div
        className={classNames(
          styles.hsAuthLayoutContent,
          isWelcomePage && styles.hsAuthLayoutContentWelcome,
        )}
      >
        {children}
      </div>
      {!hideHeaderAndFooter && <DefaultFooter />}
    </div>
  );
};

AuthenticationLayout.defaultProps = {
  description: '',
  name: '',
  type: 'summary',
  organizationLogo: undefined,
  organizationAltText: undefined,
  hideHapstarLogoEnabled: false,
};

interface AuthenticationLayoutProps {
  children: React.ReactNode | undefined;
  title: string;
  description?: string;
  name?: string;
  type?: TwitterCardType;
  organizationAltText?: string;
  organizationLogo?: string | undefined;
  hideHapstarLogoEnabled?: boolean;
}

export default AuthenticationLayout;
